import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';

export function unsubscribeFromAll(subscriptions: unknown) {
    if (!subscriptions) {
        return;
    }

    if (Array.isArray(subscriptions)) {
        subscriptions.forEach((subscription) => {
            if (subscription && subscription.unsubscribe) {
                subscription.unsubscribe();
            }
        });

        return;
    }

    if (typeof subscriptions === 'object') {
        if (subscriptions instanceof Subscription) {
            subscriptions.unsubscribe();
        } else {
            Object.keys(subscriptions).forEach((key: string) => {
                // @ts-ignore
                const subscription = subscriptions[key];

                if (subscription && subscription.unsubscribe) {
                    subscription.unsubscribe();
                }
            });
        }

        return;
    }

    if (!environment.production) {
        console.warn('Subscription object supplied is not iterable');
    }
}
